const LAST_GROUP_KEY = 'bracket_run_last_group';

export function useLastActiveGroup() {
  const lastGroupId = localStorage.getItem(LAST_GROUP_KEY);

  const setLastActiveGroup = (groupId: string) => {
    localStorage.setItem(LAST_GROUP_KEY, groupId);
  };

  return { lastGroupId, setLastActiveGroup };
}
